import { Result } from '@/classes'
import UserStore from '@/store/user'
import OrganizationStore from '@/store/organization'
import { getAppVersion, getVersion } from './native/useApp'
import { Capacitor } from '@capacitor/core'

export const fetchAPI = async <T>(
  path: string,
  body?: unknown,
  options?: {
    method?: 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT',
    headers?: HeadersInit,
    multipart?: Boolean,
    base?: string,
    isPrepend?: boolean
    isNoHeaders?: boolean
    controller?: AbortController
  }
): Promise<Result<T>> => {
  const userStore = UserStore()
  const organizationStore = OrganizationStore()
  
  const optionsWithDefaults = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    ...options
  }

  const pathUrl = options?.isPrepend !== false ? `${options?.base || useRuntimeConfig().public.API}/${path}` : path

  const getParams = optionsWithDefaults.method === 'GET' || optionsWithDefaults.method === 'DELETE' && body ? `?${new URLSearchParams(body as string[][])}` : ''

  const version = await getVersion()
  const organizationId  = await getCookie('organization') as string

  try {
    const { data, status, errors }: any = await $fetch(pathUrl + getParams, {
      ...optionsWithDefaults,
      signal: optionsWithDefaults.controller?.signal ?? undefined,
      headers: options?.isNoHeaders ? {} : {
        ...(userStore.token ? { 'Authorization': `Bearer ${userStore.token}`} : {}),
        ...(organizationId ? { 'organization': organizationId } : {}),
        ...(version ? {
          [Capacitor.isNativePlatform() ? 'app-version' : 'web-version']: version
        } : {}),
        ...(options?.multipart ? {} : optionsWithDefaults.headers),
        'Accept-Language': useNuxtApp().$i18n.locale.value
      },
      body: optionsWithDefaults.method === 'GET' || optionsWithDefaults.method === 'DELETE' || !body ? undefined : (options?.multipart ? body : JSON.stringify(body))
    })

    if ((errors ?? []).length > 0) return { ok: false, error: errors[0] }
    if (!status) return { ok: false, error: 'api-error' }
    
    return { ok: true, data }
  } catch (e: any) {
    if (options?.controller?.signal.aborted) {
      return { ok: false }
    }

    console.error(e)
    return { ok: false, error: 'api-error' }
  }
}